import { render } from "./EnergeticsLights.vue?vue&type=template&id=ba0b8760"
import script from "./EnergeticsLights.vue?vue&type=script&lang=js"
export * from "./EnergeticsLights.vue?vue&type=script&lang=js"

import "./EnergeticsLights.vue?vue&type=style&index=0&id=ba0b8760&lang=scss&scope=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__